import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getOffsetPercentage } from '../utils';

const Marks = ({
  className, vertical, marks, getPointOffset, included, upperBound, lowerBound, max, min, onClickLabel,
}) => {
  const marksKeys = Object.keys(marks);
  const marksCount = marksKeys.length;
  const unit = marksCount > 1 ? 100 / (marksCount - 1) : 100;
  const markWidth = unit * 0.9;

  const range = max - min;
  const elements = marksKeys
    .map(parseFloat)
    .sort((a, b) => a - b)
    .map((point) => {
      const markPoint = marks[point];
      const markPointIsObject = typeof markPoint === 'object' && !React.isValidElement(markPoint);
      const markLabel = markPointIsObject ? markPoint.label : markPoint;
      if (!markLabel && markLabel !== 0) {
        return null;
      }

      const isActive = (!included && point === upperBound) || (included && point <= upperBound && point >= lowerBound);
      const markClassName = classNames({
        [`${className}-text`]: true,
        [`${className}-text-active`]: isActive,
      });

      const offset = getOffsetPercentage({ point, getPointOffset, min, range });

      const bottomStyle = {
        marginBottom: '-50%',
        bottom: `${offset}%`,
      };

      const leftStyle = {
        width: `${markWidth}%`,
        marginLeft: `${-markWidth / 2}%`,
        left: `${offset}%`,
      };

      const style = vertical ? bottomStyle : leftStyle;
      const markStyle = markPointIsObject ? { ...style, ...markPoint.style } : style;
      return (
        <span aria-label="Slider mark" className={markClassName} style={markStyle} key={point} onMouseDown={e => onClickLabel(e, point)} onTouchStart={e => onClickLabel(e, point)}>
          {markLabel}
        </span>
      );
    });

  return <div className={className}>{elements}</div>;
};

Marks.propTypes = {
  className: PropTypes.string,
  vertical: PropTypes.bool,
  marks: PropTypes.object,
  getPointOffset: PropTypes.func,
  included: PropTypes.bool,
  upperBound: PropTypes.number,
  lowerBound: PropTypes.number,
  max: PropTypes.number,
  min: PropTypes.number,
  onClickLabel: PropTypes.func,
};

export default Marks;
